import {
    CREATE_PlANT,
    RETRIEVE_PLANTS,
    UPDATE_PLANT
} from "../../actions/types";
const initialState = [];
function plantReducer(plants = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case CREATE_PlANT:
            return [...plants, payload];
        case RETRIEVE_PLANTS:
            return payload;
        case UPDATE_PLANT:
            return plants.map((plant) => {
                if (plant.Plant_id === payload.Plant_id) {
                    return {
                        plant,
                        payload
                    };
                } else {
                    return plant;
                }
            });
        default:
            return plants;
    }
}

export default plantReducer;